module.exports = __webpack_public_path__ + "static/media/edit-goal-icon.4acae039.png";